export enum PcapPlaySpeedEnum {
  '1x' = 1,
  '2x' = 2,
  '4x' = 4,
  '8x' = 8,
  '16x' = 16,
}
